import type { AxiosInstance } from "axios";
import { useClient } from "../state/client";
import { initialized } from "../utils/initializedUtil";
import { useMutation } from "@tanstack/solid-query";
import type { MoreAppError } from "../MoreAppError.ts";

export type SignupRequest = {
  customerName: string;
  emailAddress: string;
  password: string;
  segment: "OTHER";
  timeZone: string;
  language: string;
  country: string;
  plan?: string;
  utmParams?: {
    source?: string;
    medium?: string;
    campaign?: string;
    content?: string;
    term?: string;
  };
};

type ValidateEmailRequest = {
  token: string;
};

let client: AxiosInstance | null = null;

const init = (): void => {
  client = useClient();
};

const getClient = () => initialized(client, "client");

const SignupService = {
  init,
  signup: () =>
    useMutation<void, MoreAppError, SignupRequest>(() => ({
      mutationFn: async (value) => {
        await getClient().post(`api/v1.0/signups/customers`, value);
      },
    })),
  validateEmail: () =>
    useMutation<void, MoreAppError, ValidateEmailRequest>(() => ({
      mutationFn: async (value) => {
        await getClient().post(`/api/v1.0/email-validation`, value, { params: value });
      },
    })),
};

export default SignupService;
